import * as yup from 'yup';
import ValidationMessage from '../../constants/Validation/ValidationMessage';
import ValidationMessageAlbanian from '../../constants/Validation/ValidationMessageChange';

const local_language = localStorage.getItem('lang')


const AddStaffMembervalidation: any = yup.object().shape({
    name: yup.string().required(local_language == "alb" ? ValidationMessageAlbanian.Field("emri") : local_language == "alb" ? ValidationMessageAlbanian.MinLength('emri', 3) : ValidationMessage.Field("name")).min(3, local_language == "alb" ? ValidationMessageAlbanian.MinLength('emri', 3) : ValidationMessage?.MinLength("name", 3)),
    category: yup.string().nullable(),
    service: yup.string().nullable(),
    address: yup.string().required(local_language == "alb" ? ValidationMessageAlbanian.Field("adresë") : ValidationMessage.Field("address")).min(5, local_language == "alb" ? ValidationMessageAlbanian.MinLength('adresë', 5) : ValidationMessage?.MinLength("address", 5))
        .max(100, local_language == "alb" ? ValidationMessageAlbanian.MaxLength('adresë', 100) : ValidationMessage?.MaxLength("address", 100)),

    email: yup.string().required(local_language == "alb" ? ValidationMessageAlbanian.Field("email") : ValidationMessage.Field("email"))
        .email(local_language == "alb" ? ValidationMessageAlbanian.EMAIL_ADDRESS : ValidationMessage.EMAIL_ADDRESS)
        .matches(ValidationMessage.EMAIL_REGREX, local_language == "alb" ? ValidationMessageAlbanian.EMAIL_ADDRESS :ValidationMessage.EMAIL_ADDRESS)
        .trim(),

    profile_img: yup.string().required(local_language == "alb" ? ValidationMessageAlbanian.PROFILE_IMAGE : 'Please select your profile image.'),

    phone_number: yup.string()
        .required(local_language == "alb" ? ValidationMessageAlbanian.Field("Numri i telefonit") : ValidationMessage.Field("phone number"))
        .min(7, local_language == "alb" ? ValidationMessageAlbanian.VALID_PHONE_NUMBER : ValidationMessage.VALID_PHONE_NUMBER)
        .max(15, local_language == "alb" ? ValidationMessageAlbanian.PHONE_MAX_CHAR : ValidationMessage.PHONE_MAX_CHAR)
        .matches(/^[0-9]*$/, local_language == "alb" ? ValidationMessageAlbanian.VALID_PHONE_NUMBER : ValidationMessage.VALID_PHONE_NUMBER) // Allow only digits
        .test('valid-phone', local_language == "alb" ? ValidationMessageAlbanian.VALID_PHONE : ValidationMessage.VALID_PHONE, value => {
            // Ensure phone number is not just repeated '0's
            if (!value) return true; // Return true if value is not provided (handled by required validation)

            if (/^0+$/.test(value)) {
                return false; // Reject if all characters are '0'
            }

            return true;
        }),


});




export default AddStaffMembervalidation;
